module.exports = __webpack_public_path__ + "img/750.15a1a4d1.jpg";